<template>
  <div class="bingo-board">
    <div
      v-for="(row, rowIndex) in grid"
      :key="rowIndex"
      class="bingo-board__row"
      :style="rowStyle"
    >
      <bingo-cell
        v-for="(cell, colIndex) in row"
        :key="colIndex"
        :cell="cell"
        :row="rowIndex"
        :col="colIndex"
        :board-mode="boardMode"
        :disabled="isCellDisabled ? isCellDisabled(cell) : false"
        :is-center="isCenterCell(rowIndex, colIndex)"
        @click-cell="onCellClick"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BingoCell from './BingoCell.vue';

export default {
  name: 'BingoBoard',
  components: { BingoCell },
  props: {
    dealId: {
      type: [Number, String],
      default: null
    },
    isCellDisabled: {
      type: Function,
      default: null
    }
  },
  emits: ['click-cell'],
  computed: {
    ...mapState('bingo', ['grid', 'boardMode', 'gridSize']),
    ...mapGetters('bingo', ['hasBingo']),
    rowStyle() {
      const size = this.gridSize || this.grid?.length || 5;
      return {
        gridTemplateColumns: `repeat(${size}, 1fr)`
      };
    }
  },
  methods: {
    isCenterCell(row, col) {
      const size = this.gridSize || this.grid?.length || 0;
      const center = Math.floor(size / 2);
      return size > 0 && row === center && col === center;
    },
    onCellClick(payload) {
      this.$emit('click-cell', payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.bingo-board {
  width: 100%;
  margin: 0 auto;
}

.bingo-board__row {
  display: grid;
  gap: 6px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
